import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicMontantRemboursement = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Remboursements', link: '/topics/paiement/remboursements'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Le montant de votre remboursement dépend entièrement
              <a target='_blank' className="link" href={`/topics/inscription/40`}>des conditions d'annulation de votre organisateur,</a>
              disponibles sur la page des détails de la compétition.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Le montant du remboursement est clairement détaillé dans les conditions générales d'annulation de la compétition. 
                Il est fixé par chaque organisateur, ce qui signifie qu'il peut varier d'une compétition à l'autre. Vous pouvez consulter 
                toutes les informations nécessaires directement sur la page de la compétition. Il est donc primordial de bien lire les clauses 
                avant de finaliser votre inscription, afin d'éviter toute mauvaise surprise.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Les remboursements auxquels vous avez droit sont gérés directement par les organisateurs suite à votre demande d'annulation. 
                Cependant, le délai de réception des fonds dépend de votre banque ou de votre établissement financier.
              </p>
              <p className="help-text">
                À noter que les procédures de remboursement peuvent prendre jusqu’à 15 jours ouvrés.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Tout ceci reste au conditionnel ! Si vous ne remplissez pas les conditions nécessaires pour être remboursé, vous pouvez toujours tenter un 
                ultime recours<a target='_blank' className="link" href={`/topics/rechercher/34`}>en contactant directement votre organisateur.</a>
                Expliquez votre situation en détail et faites appel à sa compréhension et 
                à sa générosité pour trouver une solution adaptée.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicMontantRemboursement